import { Component } from '@angular/core';
// Servicios 
import { LugaresService} from '../services/lugares.service';
import { GeolocationService} from '../services/geolocation.service';
// Sweetalert2
import swal from 'sweetalert2';
import { state, style, trigger, transition,animate } from '@angular/animations';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-lugares',
  templateUrl: './lugares.component.html',
  styleUrls: ['./lugares.component.css'],
  animations:[
    trigger('contenedorAnimable', [
      state('initial', style({
        opacity:0
        //,
        //backgroundColor:'green',
        //transform: 'rotate3d(0,0,0,0deg)'
      })),
      state('final', style({
        opacity:1
        //,
        //backgroundColor:'yellow',
        //transform: 'rotate3d(5,10,20,30deg)'        
      })),
      transition('initial => final', animate(2000)),
      transition('final => initial', animate(1000))
    ])
  ]
})

export class LugaresComponent{
  // declaraciones
  labelOptions = {
    color: '#ee4646',
    fontFamily: '',
    fontSize: '10px',
    fontWeight: 'bold',
    letterSpacing:'0.5px',
    text: 'Plan Pagado/No pagado'
  }
  
  iconMap = {
    iconUrl:"http://www.trilogic.me/public-assets/locationMarket3.ico",
    iconHeigh:10
  }

  title = 'PlatziSquare';
  a = 5;
  b = 8;
  nombre:string = '';
  estadoBoton = false;

  // variable de estado inicial 
  state = 'initial';
  /*animar(){
    this.state=(this.state=='final')?'initial':'final';
  }*/
  animacionInicia(e){
    console.log("Animacion inicial")
  }
  animacionTermina(e){
    console.log("Animacion final")
  }
  // callBacks, ejecutar algo antes de que se ejecute o termine una animacion,
  // los callbacks son eventos, 

  //geolocation:GeolocationService;
  //----------------
  /*
  lugares:any=[
    {id:1,nombre:'negocio 1', active: true, cercania:1, distancia: 1.2, plan:'pagado', descripcion:'desc'},
    {id:2,nombre:'negocio 2', active: false, cercania:3, distancia: 1.5, plan:'gratis', descripcion:'desc'},
    {id:3,nombre:'negocio 3', active: true, cercania:1, distancia: 5, plan:'pagado', descripcion:'desc'},
    {id:4,nombre:'negocio 4', active: false,cercania:2, distancia:7, plan:'gratis', descripcion:'desc'}
  ];
  */
  // variables del mapa
  lat:number = 4.5637421;
  lng:number = -75.654561; //-75.6561524;
  lugares=null;

  constructor (private lugaresService: LugaresService, private geoService:GeolocationService, private route: ActivatedRoute){
    setTimeout( ()=>{
      this.estadoBoton = true;
    }, 3000)
    // TODO: comment ()
    //this.lugares=lugaresService.getLugares();
    // SUSCRIBIR

    /* 
    TODO: refactor (forma del método)
    lugaresService.getLugares().
          valueChanges().subscribe(lugaresRes=>{    
    */
   
    lugaresService.getLugares().
      valueChanges().subscribe(lugaresRes=>{
        //debugger;        
        console.log(lugaresRes+' :: desde getLugares ');
        this.lugares=lugaresRes//.json()
        var me=this;        
        me.lugares=Object.keys(me.lugares).map(function(key){return me.lugares[key];});
        // cambiando de estado
        this.state='final';
        //debugger;
      }, error =>{
        // desplegar error o cambiar estado
        swal('Oops...','Ha ocurrido un error, los detalles son:'+error.statusText, 'error')
      });      
      //this.lugares=lugaresResp;
      // })

      /*geoService.getLocation().subscribe(data=>{
        this.lat=+data.latitude;
        this.lng=+data.longitude;
        console.log('LAT AND LNG ::: '+this.lat + ' , '+this.lng);
      });
      */
  }

  clickBoton(){
    alert('Hola');
  }
}



// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/lugares/lugares.component.ts